import { convertToShortAddress } from '~/lib/helpers';
// ---- internal imports ----

export function getStore(state) {
	return state.store;
}

export function getStoreName(state) {
	return state.store.name;
}

export function getStoreRent(state) {
	return state.store.rent;
}

export function getStoreCapacity(state) {
	return state.store.capacity;
}

export function getStoreLocation(state) {
	return state.store.location;
}

export function getStoreLocationShort(state) {
	const address = getStoreLocation(state);
	return convertToShortAddress(address);
}

export function getLocationNumber(state) {
	const location = getStoreLocation(state);
	// assuming location in format '{number}, Napolia Street. {description}'
	return location ? location[0] : 0;
}
